import { Active, Over } from '@dnd-kit/core';
import { GridStateColDef } from '@mui/x-data-grid/internals';
import {
  GridRowId,
  GridValueFormatterParams,
  GridValueGetterParams,
  GridValueSetterParams,
} from '@mui/x-data-grid-pro';
import moment from 'moment';

import { DATE_TIME_FORMAT } from 'src/shared/constants';

export const getValueOptions = <T>(options: T[], valueKey: keyof T, labelKey: keyof T) => {
  return options.map((option) => ({ value: option[valueKey], label: option[labelKey] }));
};

export const dateValueFormatter = ({ value }: GridValueFormatterParams, dateFormat: string) => {
  return value && moment(value).format(dateFormat);
};

export const dateTimeValueFormatter = (
  { value }: GridValueFormatterParams,
  dateFormat: string,
  timeFormat: string | undefined,
) => {
  return value && `${moment(value).format(dateFormat)}, ${moment(value).format(timeFormat)}`;
};

export const dateValueGetter = (params: GridValueGetterParams) => {
  return params.value ? moment(params.value) : null;
};

export const dateValueSetter = (params: GridValueSetterParams, field: string) => {
  return { ...params.row, [field]: params.value ? moment(params.value).format(DATE_TIME_FORMAT) : null };
};

export const getStaticColumnWidth = (
  columns: GridStateColDef[],
  staticColumnNames: GridStateColDef['field'][],
): number => {
  return (
    columns.reduce((width: number, column) => {
      const newWidth = column.computedWidth ?? column.minWidth ?? column.width ?? 0;
      return staticColumnNames.includes(column.field) ? width + newWidth : width;
    }, 0) ?? 0
  );
};

// Compose unique ID for drag and drop nodes using data grid cell's row ID and column field

export const getDroppableId = (gridId: GridRowId, field: string) => {
  return `droppable_${gridId}_${field}`;
};

export const getDraggableId = (gridId: GridRowId, field: string) => {
  return `draggable_${gridId}_${field}`;
};

// Extract data grid cell's row ID and column field from drag and drop nodes

export const getDragDropGridIdField = (dndNode: Active | Over): { id: GridRowId; field: string } | undefined => {
  if (typeof dndNode.id !== 'string') {
    return;
  }

  const [, id, field] = dndNode.id.split('_');

  return { id: +id, field };
};
